<script>
export default {
    name: 'StepperIcon',

    props: {
        step: {
            required: true,
        },

        currentStep: {
            required: true,
        },

        name: {
            required: false,
            default: 'Step',
        },

        icon: {
            required: false,
            default: 'zmdi zmdi-info-outline',
        },

        iconImageSrc: {
            required: false,
        },

        iconImageHeight: {
            required: false,
        },

        iconImageWidth: {
            required: false,
            // Most of the zmdi icons which are quite commonly used for
            // stepper icons seem to be 14 pixels wide so let's use the
            // same for images by default
            default: 14,
        },
    }
}
</script>

<template>
    <li :class="{ 'completed' : currentStep > step, 'active' : currentStep === parseInt(step) }">
        <span class="step-icon-wrap">
            <span v-if="iconImageSrc" class="step-icon">
                <img :src="iconImageSrc" :height="iconImageHeight" :width="iconImageWidth" v-if="currentStep <= step"></img>
                <i class="zmdi zmdi-check" v-if="currentStep > step"></i>
            </span>
            <span v-else class="step-icon">
                <i :class="icon" v-if="currentStep <= step"></i>
                <i class="zmdi zmdi-check" v-if="currentStep > step"></i>
            </span>
        </span>
        <span class="step-label">{{ name }}</span>
    </li>
</template>
